import { Component, Input, OnInit } from '@angular/core';
import { SkyCondition } from '../models/sky-condition.model';

@Component({
  selector: 'app-sky-conditions',
  templateUrl: './sky-conditions.component.html',
  styleUrls: ['./sky-conditions.component.scss'],
  preserveWhitespaces: true
})
export class SkyConditionsComponent implements OnInit {
  @Input() skyConditions: Array<SkyCondition>;

  constructor() { }

  ngOnInit() {
  }

}
